import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';
import { Navigation } from 'swiper';
import ReactHtmlParser from 'react-html-parser';
import 'swiper/swiper.scss';
import '../../global/swiperNavigation.scss';
import { neusoftBlue, white, secondBlue } from '../../colors';
import { OFFERING_PATHS } from '../Header/items';

const useStyles = makeStyles(() => ({
  careersTitleSection: {
    position: 'relative',
    width: '100%',
    height: 'auto',
    backgroundColor: white,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    '& h4': {
      fontWeight: 'normal',
      textAlign: 'center',
      width: '65%',
      marginBottom: '12rem',
      '@media(max-width:76.5em)': {
        fontSize: '1.8rem',
        width: '90%',
        marginBottom: '5rem',
      },
      '@media(max-width:47.938em)': {
        fontSize: '1.2rem',
        width: '85%',
        marginBottom: '5rem',
      },
      '@media only screen and (max-device-height : 47em) and (orientation: landscape)':
      {
        fontSize: '1.2rem',
        width: '90%',
        marginBottom: '3rem',
      },
    },
  },
  careersTitle: {
    height: '5rem',
    marginTop: '5rem',
    marginBottom: '3rem',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    '& h3': {
      color: neusoftBlue,
      textAlign: 'center',
      '@media(max-width:76.5em)': {
        margin: '0',
        fontSize: '2.2rem',
      },
      '@media(max-width:47.938em)': {
        margin: '0',
        fontSize: '1.4rem',
      },
      '@media only screen and (max-device-height : 47em) and (orientation: landscape)':
      {
        fontSize: '1.7rem',
      },
      '@media only screen and (max-device-height : 30.75em) and (orientation: landscape)':
      {
        fontSize: '1.4rem',
      },
    },
    '@media(max-width:64em)': {
      marginBottom: '3rem',
    },
    '@media(max-width:47.938em)': {
      marginTop: '2rem',
      marginBottom: '2rem',
    },
    '@media only screen and (max-device-height : 47em) and (orientation: landscape)':
    {
      margin: '3rem 0',
    },
    '@media only screen and (max-device-height : 30.75em) and (orientation: landscape)':
    {
      margin: '2rem 0',
    },
  },
  sectionLine: {
    marginTop: '0.8rem',
    backgroundColor: neusoftBlue,
    width: '8rem',
    height: '0.25rem',
    zIndex: '1',
  },
  careersSwiper: {
    width: '93%',
    margin: 'auto',
    height: 'auto',
    marginBottom: '7rem',
    marginTop: '3rem',
    '@media(max-width:85em)': {
      width: '95%',
      marginBottom: '4rem',
    },
    '@media(max-width:47.938em)': {
      width: '90%',
      marginBottom: '4rem',
    },
    '@media(max-width:85em) and (orientation: landscape)': {
      width: '95%',
      marginBottom: '4rem',
    },
  },
  offerContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    height: 'auto',
    '& h4': {
      fontWeight: 'normal',
      width: '70%',
      margin: '0 auto',
      textAlign: 'center',
      overflowWrap: 'normal',
      marginTop: '2rem',
    },
  },
  offerImage: {
    height: '3.75rem',
    '& img': {
      width: '100%',
      height: '100%',
    },
  },
  shadow: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
  paragraph: {
    '& span': {
      fontWeight: 'bold',
      color: secondBlue,
    },
  },
}));

const TitleSection = ({
  windowSize,
  items,
  label,
  titleParagraph,
  ...props
}) => {
  const classes = useStyles(props);
  const location = useLocation();
  const swiperLayout = () => {
    if (location.pathname === '/working-with-us') {
      const prevButton = document.querySelector('.swiper-button-prev');
      const nextButton = document.querySelector('.swiper-button-next');
      prevButton.style.left = '0';
      nextButton.style.right = '0';
      prevButton.style.bottom = '0';
      nextButton.style.bottom = '0';
      nextButton.style.paddingBottom = '5%';
      prevButton.style.paddingBottom = '5%';
      prevButton.style.height = '100%';
      nextButton.style.height = '100%';
      prevButton.style.width = 'auto';
      nextButton.style.width = 'auto';
      prevButton.style.backgroundColor = white;
      prevButton.style.boxShadow = '10px 0px 39px 70px #fff';
      nextButton.style.backgroundColor = white;
      nextButton.style.boxShadow = '-10px 0px 39px 70px #fff';
      if (windowSize.width > '1300') {
        nextButton.style.paddingBottom = '3%';
        prevButton.style.paddingBottom = '3%';
      }
    } else if (OFFERING_PATHS.includes(location.pathname)) {
      const prevButton = document.querySelector('.swiper-button-prev');
      const nextButton = document.querySelector('.swiper-button-next');
      prevButton.style.left = '40%';
      nextButton.style.right = '40%';
      prevButton.style.bottom = '0';
      nextButton.style.bottom = '0';
    }
  };
  useEffect(() => {
    swiperLayout();
  });

  return (
    <div className={classes.careersTitleSection}>
      <div className={classes.careersTitle}>
        <h3>{label}</h3>
        <div className={classes.sectionLine} />
      </div>
      {titleParagraph && (
        <h4 className={classes.paragraph}>{ReactHtmlParser(titleParagraph)}</h4>
      )}
      {items && (
        <div className={classes.careersSwiper}>
          <Swiper
            modules={[Navigation]}
            slidesPerView="auto"
            centeredSlides
            grabCursor
            spaceBetween={0}
            breakpoints={{
              0: { slidesPerView: '2', spaceBetween: 5 },
              640: { slidesPerView: 'auto', spaceBetween: 5 },
              768: { slidesPerView: 'auto', spaceBetween: 0 },
              1025: { slidesPerView: '6', spaceBetween: 0 },
              1400: { slidesPerView: '7', spaceBetween: 2 },
            }}
            navigation
            loop
          >
            {items.map((item) => (
              <SwiperSlide key={item.text}>
                <div className={classes.offerContent}>
                  <div className={classes.offerImage}>
                    <img src={item.image} alt="" />
                  </div>
                  <h4>{item.text}</h4>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}
    </div>
  );
};

export default TitleSection;
